module.exports = __webpack_public_path__ + "img/oops-mo.f653b866.png";